<template>
  <div class="modern-boxes-container">
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <div class="header-icon">
          <v-icon size="32" color="white">mdi-package</v-icon>
        </div>
        <div class="header-text">
          <h2 class="header-title">الصناديق</h2>
          <p class="header-subtitle">إدارة الأموال والمالية</p>
        </div>
      </div>
      <div class="header-divider"></div>
    </div>

    <!-- Financial Boxes -->
    <v-row v-if="!overlay" class="boxes-row">
      <!-- Main Treasury Box -->
      <v-col cols="4" class="box-col">
        <v-card 
          elevation="0" 
          class="modern-box main-box"
          rounded="xl"
        >
          <div class="box-content">
            <div class="box-header">
              <div class="box-icon main-icon">
                <v-icon size="28" color="white">mdi-safe</v-icon>
              </div>
              <div class="box-title-section">
                <h3 class="box-title">الصندوق الرئيسي</h3>
                <p class="box-subtitle">الرصيد الإجمالي</p>
              </div>
            </div>
            
            <div class="box-amount">
              <span class="amount-text">
                {{ (income - expenses).toLocaleString("en-US", { style: "currency", currency: "IQD" }) }}
              </span>
            </div>

            <div class="box-footer">
              <div class="trend-indicator positive" v-if="(income - expenses) >= 0">
                <v-icon size="16">mdi-trending-up</v-icon>
                <span>رصيد إيجابي</span>
              </div>
              <div class="trend-indicator negative" v-else>
                <v-icon size="16">mdi-trending-down</v-icon>
                <span>رصيد سلبي</span>
              </div>
            </div>
          </div>
        </v-card>
      </v-col>

      <!-- Income Treasury Box -->
      <v-col cols="4" class="box-col">
        <v-card 
          elevation="0" 
          class="modern-box income-box"
          rounded="xl"
        >
          <div class="box-content">
            <div class="box-header">
              <div class="box-icon income-icon">
                <v-icon size="28" color="white">mdi-trending-up</v-icon>
              </div>
              <div class="box-title-section">
                <h3 class="box-title">صندوق الإيرادات</h3>
                <p class="box-subtitle">إجمالي الدخل</p>
              </div>
            </div>
            
            <div class="box-amount">
              <span class="amount-text">
                {{ (income * 1).toLocaleString("en-US", { style: "currency", currency: "IQD" }) }}
              </span>
            </div>

            <div class="box-footer">
              <div class="detail-item">
                <span class="detail-label">مقبوضات الطلبة</span>
              </div>
            </div>
          </div>
        </v-card>
      </v-col>

      <!-- Expenses Treasury Box -->
      <v-col cols="4" class="box-col">
        <v-card 
          elevation="0" 
          class="modern-box expenses-box"
          rounded="xl"
        >
          <div class="box-content">
            <div class="box-header">
              <div class="box-icon expenses-icon">
                <v-icon size="28" color="white">mdi-trending-down</v-icon>
              </div>
              <div class="box-title-section">
                <h3 class="box-title">صندوق المصروفات</h3>
                <p class="box-subtitle">إجمالي النفقات</p>
              </div>
            </div>
            
            <div class="box-amount">
              <span class="amount-text">
                {{ (expenses * 1).toLocaleString("en-US", { style: "currency", currency: "IQD" }) }}
              </span>
            </div>

            <div class="box-footer">
              <div class="detail-item">
                <span class="detail-label">مصروفات التدريب</span>
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    trainingCenter: Number,
  },
  data: () => ({
    income: 0,
    expenses: 0,
    overlay: true,
  }),
  created() {
    this.initialData();
  },
  methods: {
    initialData() {
      let self = this;

      self.$http
        .get(`${self.$store.state.apiUrl}/homeStatistics/${self.trainingCenter}`, {
          headers: { Authorization: `Bearer ${self.$store.state.user}` },
        })
        .then((res) => {
          console.log(res);
          self.income = res.data.income;
          self.expenses = res.data.expenses;
          self.overlay = false;
        })
        .catch((err) => {
          self.overlay = false;
        });
    },
  },
};
</script>

<style scoped>
.modern-boxes-container {
  padding: 24px;
  background: transparent;
}

/* Modern Header Styles */
.modern-header {
  margin-bottom: 32px;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}

.header-icon {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #0096Ab 0%, #00BCD4 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 32px rgba(0, 150, 171, 0.3);
}

.header-text {
  flex: 1;
}

.header-title {
  font-size: 28px;
  font-weight: 700;
  color: #1F2937;
  margin: 0 0 4px 0;
  text-align: right;
}

.header-subtitle {
  font-size: 16px;
  color: #6B7280;
  margin: 0;
  text-align: right;
}

.header-divider {
  height: 4px;
  background: linear-gradient(135deg, #0096Ab 0%, #00BCD4 100%);
  border-radius: 2px;
  opacity: 0.7;
}

/* Boxes Layout */
.boxes-row {
  margin: 0 -8px;
}

.box-col {
  padding: 0 8px;
}

.modern-box {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  height: 100%;
}

.modern-box:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.box-content {
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.box-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 24px;
}

.box-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.main-icon {
  background: linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%);
  box-shadow: 0 8px 24px rgba(99, 102, 241, 0.3);
}

.income-icon {
  background: linear-gradient(135deg, #10B981 0%, #34D399 100%);
  box-shadow: 0 8px 24px rgba(16, 185, 129, 0.3);
}

.expenses-icon {
  background: linear-gradient(135deg, #EF4444 0%, #F87171 100%);
  box-shadow: 0 8px 24px rgba(239, 68, 68, 0.3);
}

.box-title-section {
  flex: 1;
  text-align: right;
}

.box-title {
  font-size: 18px;
  font-weight: 600;
  color: #1F2937;
  margin: 0 0 4px 0;
  line-height: 1.3;
}

.box-subtitle {
  font-size: 14px;
  color: #6B7280;
  margin: 0;
}

.box-amount {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 16px 0;
}

.amount-text {
  font-size: 32px;
  font-weight: 700;
  color: #1F2937;
  text-align: center;
  line-height: 1.2;
}

.box-footer {
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.trend-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  justify-content: center;
}

.trend-indicator.positive {
  color: #10B981;
}

.trend-indicator.negative {
  color: #EF4444;
}

.detail-item {
  text-align: center;
}

.detail-label {
  font-size: 14px;
  color: #6B7280;
  font-weight: 500;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .box-col {
    padding: 0 6px;
  }
  
  .amount-text {
    font-size: 28px;
  }
  
  .box-title {
    font-size: 16px;
  }
}

@media (max-width: 768px) {
  .boxes-row {
    flex-direction: column;
    margin: 0;
  }
  
  .box-col {
    padding: 0;
    margin-bottom: 16px;
  }
  
  .modern-boxes-container {
    padding: 16px;
  }
  
  .header-title {
    font-size: 24px;
  }
  
  .amount-text {
    font-size: 24px;
  }
}

@media (max-width: 480px) {
  .modern-boxes-container {
    padding: 12px;
  }
  
  .box-content {
    padding: 16px;
  }
  
  .header-content {
    gap: 12px;
  }
  
  .header-icon {
    width: 48px;
    height: 48px;
  }
  
  .header-title {
    font-size: 20px;
  }
  
  .amount-text {
    font-size: 18px;
  }
  
  .box-title {
    font-size: 14px;
  }
}
</style>
